import React from "react";
import { Badge } from "@chakra-ui/react";

const statusColorMap = {
  DRAFT: { colorScheme: "gray", label: "Draft" },
  SUBMITTED: { colorScheme: "blue", label: "Submitted" },
  IN_REVIEW: { colorScheme: "purple", label: "In Review" },
  APPROVED: { colorScheme: "green", label: "Approved" },
  REJECTED: { colorScheme: "red", label: "Rejected" },
  SENT_BACK: { colorScheme: "orange", label: "Sent Back" },
  CANCELLED: { colorScheme: "gray", label: "Cancelled" },
  PARTIALLY_APPROVED: { colorScheme: "yellow", label: "Partially Approved" },
};

const StatusBadge = ({ status }) => {
  const statusConfig = statusColorMap[status] || {
    colorScheme: "gray",
    label: status,
  };

  return (
    <Badge colorScheme={statusConfig.colorScheme} fontSize="xs" px={2} py={1}>
      {statusConfig.label}
    </Badge>
  );
};

export default StatusBadge;
